import React, { Component } from 'react';
import {
	Button,
	Col,
	Glyphicon,
	Grid,
	ListGroup,
	ListGroupItem,
	Panel,
	Row
} from 'react-bootstrap';
import PieChart from 'react-minimal-pie-chart';
import moment from 'moment-business-days';

import { retrieveEmployee } from '../../utils/retrieveEmployees';
import { retrieveRequests } from '../../utils/retrieveRequests';
import Request from '../Request/Request';
import './Employee.css';

export default class Employee extends Component {
	constructor(props) {
		super(props);

		this.state = {
			fields: {},
			today: new Date(),
			hoursReq: 0,
		}
	}

	componentWillMount() {
		const { employeeId } = this.props;

		retrieveEmployee(employeeId)
			.then(resp => {
				this.setState({ fields: resp.fields });
				if (resp.fields.employees) {
					resp.fields.employees.forEach(employee => this.loadRequests(employee));
				}
			});

		this.loadRequests(employeeId);
	}

	loadRequests(id) {
		const { addRequest } = this.props;

		retrieveRequests(id)
			.then(resp => resp.records.forEach(request => addRequest(request)));
	}

	get takenPTO() {
		if (this.state.fields.baseTakenPTO) {
			return this.props.requests.filter(request => request.fields.employeeId === this.props.employeeId).reduce((a, b) => a + b.fields.duration, 0) / 3600 + this.state.fields.baseTakenPTO;
		}

		return this.props.requests.filter(request => request.fields.employeeId === this.props.employeeId).reduce((a, b) => a + b.fields.duration, 0) / 3600;
	}

	determinePTO(rate) {
		return ((moment().week() - 1) * rate).toFixed(2);
	}

	determineBal(rate) {
		return (this.determinePTO(rate) - this.takenPTO).toFixed(2);
	}

	renderRequests() {
		const { employeeId } = this.props;

		if (this.props.requests.length > 0) {
			return this.props.requests
				.filter(request => {
					return request.fields.employeeId === employeeId
				})
				.map(request => {
					return <Request key={request.id} {...request.fields} />
				});
		}

		return <p>Loading...</p>
	}

	determineWednesday(request) {
		return this.determineEndDate(request).add(1, "weeks").startOf('week').add(3, 'days');
	}

	determineEndDate(request) {
		return moment(request.fields.dateRequested).businessAdd(request.fields.duration / 28800 - 1)
	}

	renderEmpRequests() {
		const { employeeId, editRequest } = this.props;

		if (this.props.requests.length > 0) {
			return this.props.requests
				.filter(request => {
					return request.fields.employeeId !== employeeId && !moment().isAfter(this.determineWednesday(request));
				})
				.map(request => {
					return <Request id={request.id} key={request.id} {...request.fields} editable editRequest={editRequest} dueDate={this.determineWednesday(request)}/>
				});
		}

		return <p>Loading...</p>
	}

	render() {
		const { lastName, firstName, rate } = this.state.fields;
		const { handleOpen } = this.props;

		return (
			<div style={styles.employee}>
				<h1>{lastName}, {firstName}</h1>
				<Grid>
					<Row>
						<Col xs={12} sm={12} md={6}>
							<Panel>
								<Panel.Heading>
									<Panel.Title componentClass="h2">Paid Time Off Details</Panel.Title>
								</Panel.Heading>
								<ListGroup>
									<ListGroupItem header="Rate">{parseFloat(rate).toFixed(2)} hrs/wk</ListGroupItem>
									<ListGroupItem header="PTO Accumulated">{this.determinePTO(rate)} hours</ListGroupItem>
									<ListGroupItem header="PTO Taken">{this.takenPTO} hours</ListGroupItem>
									<ListGroupItem header="PTO Balance">{this.determineBal(rate)} hours</ListGroupItem>
								</ListGroup>
							</Panel>
						</Col>
						<Col xs={12} sm={12} md={6}>
							<Panel>
								<Panel.Heading>
									<div style={{width: "inherit", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
										<Panel.Title style={{display: "inline-block"}}>Paid Time Off Requests</Panel.Title>
										<Button bsSize="small" onClick={handleOpen}>
											<Glyphicon glyph="plus" />
										</Button>
									</div>
								</Panel.Heading>
								<ListGroup style={{maxHeight: '226px', overflowY: "scroll"}}>
									{this.renderRequests()}
								</ListGroup>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col md={6}>
							<Panel bsClass="pie panel">
								<Panel.Body>
									{ rate ? (
														<PieChart
															animate
															animationDuration={1500}
															startAngle={270}
															style={{height: 300}}
															lineWidth={30}
															data={[
																{ value: this.takenPTO / this.determinePTO(rate), color: '#e35183' },
																{ value: this.determineBal(rate) / this.determinePTO(rate),
																	color: '#419763' },
															]}
								  					/>
									) : (
										<p>Loading...</p>
									)}
								</Panel.Body>
							</Panel>
	  				</Col>
	  				{ this.state.fields.employees ? (
	  					<Col md={6}>
	  						<Panel>
	  							<Panel.Heading>
	  								Employee Requests
	  							</Panel.Heading>
	  							<ListGroup>
	  								{this.renderEmpRequests()}
	  							</ListGroup>
	  						</Panel>
	  					</Col>
	  				) : (
	  					null
	  				)}
					</Row>
				</Grid>
			</div>
		)
	}
}

const styles = {
	employee: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	}
}


// WEBPACK FOOTER //
// ./src/components/Employee/Employee.js